export default __webpack_public_path__ + "static/full_dev_monitor-abbcf06ff88f090512c9a5273a6d7810.svg";